var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"switcher align-baseline",attrs:{"tabindex":"0"},on:{"click":_vm.switchTheme}},[(this.$store.state.dark)?_c('unicon',{attrs:{"name":"sun","fill":"white","aria-label":"Switch to light mode"}}):_c('unicon',{attrs:{"name":"moon","fill":"black","aria-label":"Switch to dark mode"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }